/**
 * documentation at
 * https://webartelier.de/fee_doc/list_classes.html#tabs
 */


class Tabs {

  static init = (params) => {
    const selTabModule = `${params.selModule}:not(.is-initialized)`;
    const allTabModules = document.querySelectorAll(selTabModule);

    allTabModules.forEach(tabModule => {
      new Tabs(tabModule, params);
    })
  }



  constructor(tabModule, params) {
    this.module = tabModule;
    this.selTabTitle = params.selTabTitle;
    this.selTabContent = params.selTabContent;
    this.itemsMap = {};
    this.activeItem = '';

    this.markInitialized();
    this.createItemMap();
    this.showOrphanedContent();
    this.activateLinkedTab();
    this.activateDefaultTab();
    this.startListening();
  }



  markInitialized = () => {
    this.module.classList.add('is-initialized');
  }



  createItemMap = () => {
    const allTabTitles = this.module.querySelectorAll(this.selTabTitle);

    allTabTitles.forEach(tabTitle => {
      const target = tabTitle.dataset.content;
      if (!target) return;

      const tabContentItem = document.getElementById(target);
      if (!tabContentItem) {
        this.handleMissingContentItem(target);
        return;
      }

      this.itemsMap[target] = { tabTitle, tabContentItem };
    })
  }



  showOrphanedContent = () => {
    const allContentItems = this.module.querySelectorAll(this.selTabContent);

    allContentItems.forEach(contentItem => {
      if (!this.itemsMap.hasOwnProperty(contentItem.id)) {
        this.handleOrphanedContent(contentItem.id);
      }
    });
  }



  activateLinkedTab = () => {
    if (!location.hash) return;

    const target = location.hash.replace('#', '');

    if (!this.itemsMap.hasOwnProperty(target)) {
      this.handleMissingLinkedItem(item);
      return
    }

    this.openTab(this.itemsMap[target]);
  }



  activateDefaultTab = () => {
    if (this.activeItem) return;
    const firstTabtitle = Object.values(this.itemsMap)[0];
    this.openTab(firstTabtitle);
  }



  startListening = () => {
    this.module.addEventListener('click', (e) => {
      const target = e.target;
      const clickedTabTitle =
        Object.values(this.itemsMap).find(item => item.tabTitle === target);

      if (!clickedTabTitle) return;
      if (clickedTabTitle != this.activeItem) this.openTab(clickedTabTitle);
    })
  };



  openTab = (item) => {
    this.closeActiveTab();
    this.toggleItemClass(item, 'add');
    this.activeItem = item;
  }



  closeActiveTab = () => {
    if(!this.activeItem) return;
    this.toggleItemClass(this.activeItem, 'remove');
  }



  toggleItemClass = (item, action) => {
    ['tabTitle', 'tabContentItem'].forEach(prop => {
      item[prop].classList[action]('is-activeTab');
    })
  }



  handleOrphanedContent = (item) => {
    console.warn(`Orphaned tab content item '${item}'`);
  }



  handleMissingLinkedItem = (item) => {
    console.warn(`Missing linked item '${item}'`);
  }



  handleMissingContentItem = (item) => {
    console.warn(`Missing tab content '${item}'`);
  }
}
